export default __webpack_public_path__ + "static/media/celebrate.457fb14594fbbf5064f15d61b9c1b1e2.svg";